import React, {Fragment} from "react";
import {Formik} from "formik";
import PropTypes from 'prop-types';
import {FieldLayoutTwoColumn, PrimaryButton} from "cstar-react-primitives";

import {useFormatMessage} from "../../../../intl/intlHooks";
import {CCSecurityCodeFormikField, SECURITY_CODE} from "../creditCard/CreditCardFields";
import {creditCardMessages as msgs} from "../creditCard/creditCardMessages";
import {LoyaltyProvider} from "../../../loyalty/LoyaltyProvider";
import PointsNotice from "../../../loyalty/PointsNotice";
import {cashbotName} from "../../../core";
import {creditCardFormMessages} from "../creditCard/creditCardFormMessages";
import {useOrder} from "../../../../mapi/OrderProvider";
import {useUsers} from "../../../../user/UserContext";
import {isObjectEmpty} from "../../../../utils/sharedFunctions";
import {getStoredPaymentValidationSchema} from "./storedPaymentValidation";
import {TermsAgreementInfoField} from "../../../forms/fields/TermsAgreementInfoField";

export const InnerStoredPaymentForm = ({handleSubmit, values}) => {
    const formatMessage = useFormatMessage();
    const {orderStatusProcessing, orderHasStatusError} = useOrder();
    return (
        <form onSubmit={handleSubmit}>
            <Fragment>
                <div className='stored-payment-billing'>
                    <div className='stored-payment-billing--name'>{values.billingFullName}</div>
                    <div className='stored-payment-billing--address'>{values.address}</div>
                </div>
                <FieldLayoutTwoColumn>
                    <CCSecurityCodeFormikField label={formatMessage(msgs.securityCodeLabel)} />
                </FieldLayoutTwoColumn>
                <LoyaltyProvider>
                    <PointsNotice />
                </LoyaltyProvider>
                <TermsAgreementInfoField />
                <div className="checkout-actions">
                    <PrimaryButton
                        atts={{disabled: (orderStatusProcessing && !orderHasStatusError)}}
                        type="submit"
                        cashbotName={cashbotName}
                        btnText={formatMessage(creditCardFormMessages.checkoutButtonText)}
                    />
                </div>
            </Fragment>
        </form>
    );
};

InnerStoredPaymentForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    values: PropTypes.shape({
        billingFullName: PropTypes.string.isRequired,
        address: PropTypes.string.isRequired
    }).isRequired
};

export const StoredCreditCardFormik = ({uuid}) => {
    const { placeOrder } = useOrder();
    const { userData } = useUsers();

    const submitHandler = values => {
        placeOrder(values)
    };

    const getPaymentFromUUID = (paymentUUID) => {
        const storedPayments = !isObjectEmpty(userData) ? userData.storedPayments : [];
        return storedPayments.find(payment => payment.storedPaymentUUID === paymentUUID);
    };
    const payment = getPaymentFromUUID(uuid);

    const initialValues = {
        [SECURITY_CODE]: '',
        storedPaymentUuid: uuid,
        paymentMethod: 'storedPayment',
        currencyCode: 'USD',
        email: userData.email,
        firstName: userData.firstName,
        lastName: userData.lastName,
        fullName: `${userData.firstName} ${userData.lastName}`,
        cardType: payment.cardType,
        billingFullName: `${payment.firstName} ${payment.lastName}`,
        address: `${payment.streetAddress}${payment.streetAddress2 ? (` ${payment.streetAddress2}`): ''}, ${payment.city},
                    ${payment.region}, ${payment.postalCode}`,
        creditCard: payment.cardNumLast4
    };

    return (
        <Formik
            onSubmit={submitHandler}
            initialValues={initialValues}
            children={formProps => <InnerStoredPaymentForm {...formProps} />}
            validationSchema={getStoredPaymentValidationSchema(useFormatMessage())}
        />
    );
};

StoredCreditCardFormik.propTypes = {
    uuid: PropTypes.string.isRequired
};

export default StoredCreditCardFormik;
